import { WebSearchCriteria } from '../../../services/dtos';

export function stringifyWebSearchCriteriaContact(webSearchCriteria: WebSearchCriteria) {
  const contactValues = {
    name: webSearchCriteria.name,
    email: webSearchCriteria.email,
    phoneNumber: webSearchCriteria.phoneNumber,
    optIns: webSearchCriteria.optIns,
  };

  return JSON.stringify(contactValues);
}
